import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
console.log('history',history);
export default history;